import { collection, getFirestore } from "firebase/firestore";
import firebaseApp from '../firebase';

const CollectionsDev = {
    APP: "App",
    ARTICLES: "Articles",
    CONTACT_MESSAGES: "ContactMessages",
    SELLER_REPORTS: "SellerReports",
    SOCIAL_MEDIA_TUTORIAL: "SocialMediaTutorial",
    USERS: "Users",
    SUBSCRIPTIONS: "Subscriptions",
    POSTS: "PostsDev",
    ORDERS: "OrdersDev",
    USER_ORDERS: "UserOrdersDev",
}

const CollectionsProd = {
    APP: "App",
    ARTICLES: "Articles",
    CONTACT_MESSAGES: "ContactMessages",
    SELLER_REPORTS: "SellerReports",
    SOCIAL_MEDIA_TUTORIAL: "SocialMediaTutorial",
    USERS: "Users",
    SUBSCRIPTIONS: "Subscriptions",
    POSTS: "Posts",
    ORDERS: "Orders",
    USER_ORDERS: "UserOrders",
}

export const Collections = CollectionsProd;

export class CollectionsClass {

    static instance = getFirestore(firebaseApp);

    static appCollection = collection(this.instance, Collections.APP);
    static usersCollection = collection(this.instance, Collections.USERS);
    static postsCollection = collection(this.instance, Collections.POSTS);
    static articlesCollection = collection(this.instance, Collections.ARTICLES);
    static contactMessagesCollection = collection(this.instance, Collections.CONTACT_MESSAGES);
    static sellerReportsCollection = collection(this.instance, Collections.SELLER_REPORTS);
    static ordersCollection = collection(this.instance, Collections.ORDERS);
    static userOrdersCollection = collection(this.instance, Collections.USER_ORDERS);
    static socialMediaTutorialCollection = collection(this.instance, Collections.SOCIAL_MEDIA_TUTORIAL);
    static subscriptionsCollection = collection(this.instance, Collections.SUBSCRIPTIONS);
}